import { render, staticRenderFns } from "./PromotionProductsTable.vue?vue&type=template&id=8361275c"
import script from "./PromotionProductsTable.vue?vue&type=script&lang=js"
export * from "./PromotionProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports